import { tsScreenCollection } from '../../../../Typescript/DB_Interface'

export function validCollection(
  addCollection: Partial<tsScreenCollection> | undefined,
) {
  return (
    addCollection?.SampleType &&
    addCollection?.Criteria &&
    addCollection?.DestinationFacilityID &&
    addCollection?.SampleSource &&
    addCollection?.Tests &&
    addCollection.Tests.length > 0 &&
    addCollection?.CriteriaDetails &&
    addCollection.CriteriaDetails.length > 0 &&
    (typeof parseInt(addCollection?.SampleSource) === 'number' ||
      (addCollection?.SampleSource === '9' &&
        addCollection?.SampleSourceOther &&
        addCollection.SampleSourceOther.length > 0))
  )
}
